import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LayoutModule } from './layout/layout.module';
import { MangoLayoutComponent } from './mango-layout.component';

@NgModule({
  declarations: [MangoLayoutComponent],
  imports: [LayoutModule],
  exports: [MangoLayoutComponent],
  providers: [CookieService],
})
export class MangoLayoutModule {}
